import React, { Component } from 'react';
import { Link } from '@zocdoc-frontend-common/components-link';

export class SyncErrorModalDescription extends Component {
    render() {
        const { phoneNumber } = this.props;

        return (
            <div data-test="error-modal-description">
                Please call their office to make your appointment:{' '}
                <Link href={`tel:${phoneNumber}`}>{phoneNumber}</Link>
            </div>
        );
    }
}
